import type {
  GiftCard,
  InternalGiftCardProperties,
  ManualGiftCardProperties,
  VoucherGiftCardProperties,
} from 'app/typings/giftCard';
import { GiftCardType } from 'app/typings/giftCard';
import { capitalizeFirstLetter } from 'app/utils/string';

import { Line } from '../Line/Line';

type Props = {
  giftCard: GiftCard &
    (
      | VoucherGiftCardProperties
      | InternalGiftCardProperties
      | ManualGiftCardProperties
    );
};

export const VoucherProperties = ({ giftCard }: Props) => {
  const { giftCardType, beneficiaryName, minAmount } = giftCard;

  return (
    <>
      <Line
        title="Type"
        value={
          giftCardType === GiftCardType.Manual
            ? 'Manual Gift Card'
            : capitalizeFirstLetter(giftCardType)
        }
      />
      <Line title="Beneficiary name" value={beneficiaryName} />
      <Line title="Minimum code use amount" value={minAmount} />
    </>
  );
};
